'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _jsx = require('@babel/runtime/helpers/jsx');
var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
var React = require('react');
var classNames = require('classnames');
var focus = require('@react-aria/focus');
var common = require('@andes/common');
var autofocus = require('@andes/common/build/utils/autofocus');
var context = require('@andes/context');
var keyboardCodes = require('@andes/common/build/constants/keyboardCodes');
var CloseIcon16 = require('@andes/icons/Close16');
var CloseIcon20 = require('@andes/icons/Close20');
var SearchIcon16 = require('@andes/icons/Search16');
var SearchIcon20 = require('@andes/icons/Search20');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var dropdown = require('@andes/dropdown');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _jsx__default = /*#__PURE__*/_interopDefaultLegacy(_jsx);
var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var CloseIcon16__default = /*#__PURE__*/_interopDefaultLegacy(CloseIcon16);
var CloseIcon20__default = /*#__PURE__*/_interopDefaultLegacy(CloseIcon20);
var SearchIcon16__default = /*#__PURE__*/_interopDefaultLegacy(SearchIcon16);
var SearchIcon20__default = /*#__PURE__*/_interopDefaultLegacy(SearchIcon20);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var module$3 = "@andes/search-box";
var locale$2 = "en-US";
var translations$2 = {
  "andes-search-box\u0004Abrir buscador": [null, "Open search tool"],
  "andes-search-box\u0004Buscar": [null, "Search"],
  "andes-search-box\u0004Borrar": [null, "Delete search"]
};
var enTranslations = {
  module: module$3,
  locale: locale$2,
  translations: translations$2
};
var module$2 = "@andes/search-box";
var locale$1 = "es-AR";
var translations$1 = {
  "andes-search-box\u0004Abrir buscador": [null, "Abrir buscador"],
  "andes-search-box\u0004Buscar": [null, "Buscar"],
  "andes-search-box\u0004Borrar": [null, "Borrar"]
};
var esTranslations = {
  module: module$2,
  locale: locale$1,
  translations: translations$1
};
var module$1 = "@andes/search-box";
var locale = "pt-BR";
var translations = {
  "andes-search-box\u0004Abrir buscador": [null, "Abrir mecanismo de busca"],
  "andes-search-box\u0004Buscar": [null, "Procurar"],
  "andes-search-box\u0004Borrar": [null, "Apagar busca"]
};
var ptTranslations = {
  module: module$1,
  locale: locale,
  translations: translations
};
var _SearchIcon2, _SearchIcon3, _CloseIcon, _CloseIcon2;
const namespace = 'andes-form-control';
const searchNamespace = "".concat(namespace, "--search-box");
const searchTranslationsNamespace = 'andes-search-box';
const SearchBox = /*#__PURE__*/function () {
  const SearchBox = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    var _SearchIcon;
    let {
      className,
      collapsed = false,
      defaultValue,
      inputProps = {},
      onChange,
      onClear,
      onKeyDown,
      onTriggerClick,
      placeholder,
      size = 'small',
      splitMenu,
      autoFocus = false,
      srLabel,
      trigger,
      value
    } = _ref;
    const i18n = context.getPatchedI18n(context.AndesContext, enTranslations, esTranslations, ptTranslations);
    const inputRef = React.useRef(null);
    const firstRender = React.useRef(true);
    const isCollapsable = React.useRef(collapsed);
    const [triggerFadeOut, setTriggerFadeOut] = React.useState(false);
    const [inputFadeIn, setInputFadeIn] = React.useState(false);
    const [isTriggerVisible, setIsTriggerVisible] = React.useState(collapsed && size === 'small');
    const [focused, setFocused] = React.useState(false);
    const [showClear, setShowClear] = React.useState(false);
    const isControlled = React.useMemo(() => typeof value !== 'undefined', []);
    React.useEffect(() => {
      if (!isControlled && defaultValue) {
        setShowClear(true);
      }
    }, []);
    React.useEffect(() => {
      if (isControlled) {
        const showClearButton = Boolean(value && (value === null || value === void 0 ? void 0 : value.length) > 0);
        setShowClear(showClearButton);
      }
    }, [isControlled, value, setShowClear]);
    React.useEffect(() => {
      const inputVisible = inputRef.current && !isCollapsable.current;
      const isFirstRender = firstRender.current;
      if (isFirstRender) {
        if (inputVisible && (focused || autoFocus)) {
          autofocus.autofocus(inputRef.current, firstRender.current);
        }
        firstRender.current = false;
      } else if (focused) {
        var _inputRef$current;
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
      }
    }, [focused, autoFocus]);
    React.useEffect(() => {
      if (!firstRender.current && isCollapsable.current) {
        if (!collapsed) {
          setTriggerFadeOut(true);
          setIsTriggerVisible(false);
          setTimeout(() => {
            setInputFadeIn(true);
            setFocused(true);
          }, 50);
        } else {
          setInputFadeIn(false);
          setTimeout(() => {
            setIsTriggerVisible(true);
            setTriggerFadeOut(false);
          }, 50);
        }
      }
    }, [collapsed]);
    const handleTriggerClick = event => {
      if (trigger) {
        trigger.props.onClick(event);
      } else if (typeof onTriggerClick === 'function') {
        onTriggerClick(event);
      }
    };
    const triggerClassNames = classNames__default["default"]("".concat(namespace, "__search-trigger"), {
      ["".concat(namespace, "__search-trigger--hidden")]: !isTriggerVisible,
      ["".concat(namespace, "__search-trigger--fadeout")]: triggerFadeOut,
      ["".concat(namespace, "__search-trigger--default")]: !trigger
    });
    const triggerProps = {
      'aria-label': "".concat(srLabel || i18n.pgettext(searchTranslationsNamespace, 'Abrir buscador')),
      type: 'button',
      className: triggerClassNames,
      onClick: event => {
        handleTriggerClick(event);
      }
    };
    const getTrigger = () => {
      if (trigger) {
        return /*#__PURE__*/React.cloneElement(trigger, _objectSpread__default["default"]({}, triggerProps));
      }
      return /*#__PURE__*/React__default["default"].createElement("button", triggerProps, _SearchIcon || (_SearchIcon = /*#__PURE__*/_jsx__default["default"](SearchIcon, {})));
    };
    const SearchIcon = () => {
      if (size === 'small') {
        return _SearchIcon2 || (_SearchIcon2 = /*#__PURE__*/_jsx__default["default"](SearchIcon16__default["default"], {}));
      }
      return _SearchIcon3 || (_SearchIcon3 = /*#__PURE__*/_jsx__default["default"](SearchIcon20__default["default"], {}));
    };
    const CloseIcon = () => {
      if (size === 'small') {
        return _CloseIcon || (_CloseIcon = /*#__PURE__*/_jsx__default["default"](CloseIcon16__default["default"], {}));
      }
      return _CloseIcon2 || (_CloseIcon2 = /*#__PURE__*/_jsx__default["default"](CloseIcon20__default["default"], {}));
    };
    const handleChange = event => {
      var _inputRef$current2, _inputRef$current3;
      const showClearButton = Boolean((inputRef === null || inputRef === void 0 || (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.value) && (inputRef === null || inputRef === void 0 || (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 ? void 0 : _inputRef$current3.value.length) > 0);
      setShowClear(showClearButton);
      if (typeof onChange === 'function') onChange(event);
    };
    const handleClear = event => {
      var _inputRef$current4;
      event.preventDefault();
      if (!isControlled && inputRef.current) inputRef.current.value = '';
      event.target.value = '';
      setShowClear(false);
      if (typeof onClear === 'function') onClear(event);
      if (typeof onChange === 'function') {
        onChange(event);
      }
      (_inputRef$current4 = inputRef.current) === null || _inputRef$current4 === void 0 || _inputRef$current4.focus();
    };
    const handleBlur = event => {
      const {
        onBlur
      } = inputProps;
      setFocused(false);
      if (typeof onBlur === 'function') onBlur(event);
    };
    const handleFocus = event => {
      const {
        onFocus
      } = inputProps;
      setFocused(true);
      if (typeof onFocus === 'function') onFocus(event);
    };
    const handleKeyDown = event => {
      if (event.code === keyboardCodes.ESCAPE) {
        event.stopPropagation();
        if (!isControlled && inputRef.current) inputRef.current.value = '';
        event.target.value = '';
        setShowClear(false);
      }
      if (typeof onKeyDown === 'function') onKeyDown(event);
    };
    const dismissClassNames = classNames__default["default"]("".concat(namespace, "__close-icon"), {
      ["".concat(namespace, "__close-icon-visible")]: showClear
    });
    const wrapperClassNames = classNames__default["default"](searchNamespace, "".concat(searchNamespace, "--size-").concat(size), className, {
      ["".concat(searchNamespace, "--focused")]: focused,
      ["".concat(searchNamespace, "--always-visible")]: !isCollapsable.current,
      ["".concat(searchNamespace, "--fadein")]: inputFadeIn,
      ["".concat(searchNamespace, "--hidden")]: isTriggerVisible,
      ["".concat(searchNamespace, "--disabled")]: inputProps.disabled
    });
    return /*#__PURE__*/React__default["default"].createElement("div", {
      ref: ref
    }, getTrigger(), /*#__PURE__*/_jsx__default["default"](focus.FocusRing, {
      within: true,
      isTextInput: true,
      focusRingClass: "focus-visible"
    }, void 0, /*#__PURE__*/_jsx__default["default"]("div", {
      className: wrapperClassNames
    }, void 0, splitMenu, /*#__PURE__*/_jsx__default["default"]("label", {}, void 0, /*#__PURE__*/_jsx__default["default"](common.VisuallyHidden, {}, void 0, srLabel || i18n.pgettext(searchTranslationsNamespace, 'Buscar')), /*#__PURE__*/React__default["default"].createElement("input", _extends__default["default"]({}, inputProps, {
      className: "".concat(namespace, "__field"),
      value: value,
      defaultValue: defaultValue,
      placeholder: placeholder || "".concat(i18n.pgettext(searchTranslationsNamespace, 'Buscar')),
      onChange: handleChange,
      onBlur: handleBlur,
      onFocus: handleFocus,
      ref: inputRef,
      onKeyDown: handleKeyDown,
      autoFocus: focused || autoFocus
    }))), /*#__PURE__*/_jsx__default["default"]("button", {
      className: dismissClassNames,
      onClick: handleClear,
      onMouseDown: handleClear,
      "aria-label": "".concat(i18n.pgettext(searchTranslationsNamespace, 'Borrar')),
      type: "button"
    }, void 0, /*#__PURE__*/_jsx__default["default"](CloseIcon, {})), /*#__PURE__*/_jsx__default["default"]("button", {
      className: "".concat(namespace, "__search-icon"),
      "aria-label": srLabel || "".concat(i18n.pgettext(searchTranslationsNamespace, 'Buscar'))
    }, void 0, /*#__PURE__*/_jsx__default["default"](SearchIcon, {})))));
  });
  SearchBox.displayName = 'SearchBox';
  return SearchBox;
}();
var SearchBox$1 = SearchBox;
const formNamespace = 'andes-form-control';
const searchboxNamespace = "".concat(formNamespace, "--search-box");
const _excluded = ["className", "defaultSelectedOption", "disabled", "dropdownType", "onChangeSelection", "options", "size", "srDropdownLabel"];
const SearchboxSplit = /*#__PURE__*/function () {
  const SearchboxSplit = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    let {
        className,
        defaultSelectedOption = 0,
        disabled = false,
        dropdownType = 'text',
        onChangeSelection,
        options,
        size = 'small',
        srDropdownLabel
      } = _ref,
      searchboxProps = _objectWithoutProperties__default["default"](_ref, _excluded);
    const [isOpen, setIsOpen] = React.useState(false);
    const wrapperClassNames = classNames__default["default"](className, "".concat(searchboxNamespace, "-split"), "".concat(searchboxNamespace, "-split--size-").concat(size), {
      ["".concat(searchboxNamespace, "-split--disabled")]: disabled,
      ["".concat(searchboxNamespace, "-split--open")]: isOpen
    });
    const renderCustomTrigger = currentValue => {
      const option = options.find(_ref2 => {
        let {
          title
        } = _ref2;
        return currentValue === title;
      });
      return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, dropdownType === 'icon' && size === 'small' ? /*#__PURE__*/_jsx__default["default"]("div", {
        className: "".concat(searchboxNamespace, "-split--dropdown-trigger")
      }, void 0, /*#__PURE__*/_jsx__default["default"](common.VisuallyHidden, {}, void 0, option === null || option === void 0 ? void 0 : option.title), option === null || option === void 0 ? void 0 : option.icon) : /*#__PURE__*/_jsx__default["default"]("span", {
        className: "".concat(searchboxNamespace, "-split--dropdown-trigger")
      }, void 0, option === null || option === void 0 ? void 0 : option.title));
    };
    const getDefaultValue = () => {
      var _options;
      return (_options = options[defaultSelectedOption || 0]) === null || _options === void 0 ? void 0 : _options.title;
    };
    const splitMenu = /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/_jsx__default["default"](dropdown.DropdownStandalone, {
      label: srDropdownLabel,
      defaultValue: getDefaultValue(),
      disabled: disabled,
      renderCustomTrigger: renderCustomTrigger,
      onChange: onChangeSelection,
      size: size === 'large' ? 'medium' : 'small',
      className: "".concat(searchboxNamespace, "-split--dropdown"),
      onOpen: () => setIsOpen(true),
      onClose: () => setIsOpen(false)
    }, void 0, options === null || options === void 0 ? void 0 : options.map(_ref3 => {
      let {
        id,
        icon,
        title
      } = _ref3;
      return /*#__PURE__*/_jsx__default["default"](dropdown.DropdownItem, {
        value: title,
        leftContent: icon,
        title: title
      }, id);
    })), /*#__PURE__*/_jsx__default["default"]("div", {
      className: "".concat(searchboxNamespace, "-split--divider")
    }));
    return /*#__PURE__*/React__default["default"].createElement("div", {
      ref: ref,
      className: wrapperClassNames
    }, /*#__PURE__*/React__default["default"].createElement(SearchBox$1, _extends__default["default"]({}, searchboxProps, {
      size: size,
      inputProps: _objectSpread__default["default"](_objectSpread__default["default"]({}, searchboxProps.inputProps), {}, {
        disabled
      }),
      splitMenu: splitMenu
    })));
  });
  SearchboxSplit.displayName = 'SearchboxSplit';
  return SearchboxSplit;
}();
var SearchboxSplit$1 = SearchboxSplit;
exports.SearchBox = SearchBox$1;
exports.SearchboxSplit = SearchboxSplit$1;
exports["default"] = SearchBox$1;
